import { SelectSimple } from '@advanza/input'
import { SelectSimpleChangeEvent } from '@advanza/input/interfaces/SelectSimpleChangeEvent'
import { Button } from '@advanza/ui'
import InputField from '@trustoo/components/input/InputField'
import { useState } from 'react'

const COUNTRY_OPTIONS = [
    { value: '', name: 'All countries' },
    { value: 'NL', name: 'NL' },
    { value: 'BE', name: 'BE' },
    { value: 'DE', name: 'DE' },
    { value: 'ES', name: 'ES' },
]

const DEFAULT_BATCH_MULTIPLIER = 1
const MAX_BATCH_MULTIPLIER = 100

const PreviewDemandQuickReplies = () => {
    const [countryCode, setCountryCode] = useState('')
    const [batchMultiplier, setBatchMultiplier] = useState(DEFAULT_BATCH_MULTIPLIER)
    const [matchIds, setMatchIds] = useState('')

    const handleExport = () => {
        const { protocol, hostname } = window.location
        const params = new URLSearchParams()
        params.set(
            'batch_multiplier',
            String(Math.min(Math.max(1, batchMultiplier), MAX_BATCH_MULTIPLIER)),
        )
        if (countryCode) {
            params.set('country_code', countryCode)
        }
        const matchIdsTrimmed = matchIds.trim()
        if (matchIdsTrimmed) {
            params.set('match_ids', matchIdsTrimmed)
        }
        const exportUrl = `${protocol}//${hostname}/api/office/misc/preview-demand-quick-replies?${params.toString()}`
        window.open(exportUrl, '_blank', 'noopener,noreferrer')
    }

    return (
        <div className="space-y-4">
            <div className="flex flex-wrap gap-4 items-end">
                <SelectSimple
                    className="min-w-[140px]"
                    legend
                    placeholder="Country"
                    value={countryCode}
                    onChange={(e: SelectSimpleChangeEvent) =>
                        setCountryCode(String(e.target.value ?? ''))
                    }
                    options={COUNTRY_OPTIONS}
                />
                <InputField
                    legend="Batch multiplier"
                    type="number"
                    min={1}
                    max={MAX_BATCH_MULTIPLIER}
                    value={batchMultiplier}
                    onChange={(e) =>
                        setBatchMultiplier(Number(e.target.value) || DEFAULT_BATCH_MULTIPLIER)
                    }
                />
                <InputField
                    legend="Match ID(s)"
                    type="text"
                    value={matchIds}
                    onChange={(e) => setMatchIds(e.target.value)}
                    placeholder="e.g. 123 or 123,124,125"
                />
                <Button appearance="primary" onClick={handleExport} className="h-[46px]">
                    Export CSV
                </Button>
            </div>
            <p className="text-sm text-text-secondary-700">
                Generates AI quick replies for recent matches or for specific match IDs (comma
                separated). When not using match IDs, matches are grouped into batches: each batch
                is one combination of country (e.g. NL, BE) and conversation state (initial, after
                auto reply, after manual reply).
            </p>
        </div>
    )
}

export default PreviewDemandQuickReplies
